import { RefObject, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useLogRootViewHtml = (rootRef: RefObject<HTMLElement | null>) => {
  const location = useLocation();
  const [textContent, setTextContent] = useState('');

  useLayoutEffect(() => {
    const container = rootRef.current;

    if (!container) {
      return;
    }

    let timer: ReturnType<typeof setTimeout>;

    const schedule = () => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        const text = (container.textContent ?? '').replace(/\s+/g, ' ').trim();
        setTextContent(prev => (prev !== text ? text : prev));
      }, 5000);
    };

    schedule();

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [rootRef, location.key]);

  const reloadTrigger = () => {
    const container = rootRef.current;

    if (!container) {
      return;
    }

    const text = (container.textContent ?? '').replace(/\s+/g, ' ').trim();
    setTextContent(prev => (prev !== text ? text : prev));
  };

  return { textContent, reloadTrigger };
};
